import React from "react";
import "./HallFameContent.css";

function HallFameContent() {
  return (
    <>
      <div className="hallfame-banner-wrap">
        <img
          src={process.env.PUBLIC_URL + "/Assets/Home/Ignite-banner3.png"}
          alt="Ignite banner"
          className="banner-img"
        />
        <div className="hallfame-content-box">
          <h1>Hall of Fame</h1>
          <h2>Coming Soon</h2>
          <img
            src={
              process.env.PUBLIC_URL + "/Assets/HallFame/coming-border-img.png"
            }
            alt="border"
            className="coming-border-img"
          />
        </div>
        <div className="hallfame-img-box">
          <img
            src={
              process.env.PUBLIC_URL + "/Assets/HallFame/announcement-person.png"
            }
            alt="announcement-person"
            className="announcement-person"
          />
        </div>
      </div>
    </>
  );
}

export default HallFameContent;
